import { render, staticRenderFns } from "./AboutNewSection.vue?vue&type=template&id=494fe318&scoped=true"
import script from "./AboutNewSection.vue?vue&type=script&lang=js"
export * from "./AboutNewSection.vue?vue&type=script&lang=js"
import style0 from "./AboutNewSection.vue?vue&type=style&index=0&id=494fe318&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fe318",
  null
  
)

export default component.exports